import { Link } from 'react-router-dom';
import { Icon } from '@/lib/icons';
import { cn } from '@/lib/cn';
import { useRueckweg } from '@/lib/seitenverlauf';

/**
 * Rückweg dorthin, wo der Nutzer hergekommen ist — steht in der Hülle über
 * jeder Seite. Die Regeln dahinter stehen in `lib/seitenverlauf`.
 *
 * Rendert nichts, wenn es nichts zu sagen gibt: auf den Hauptseiten direkt
 * nach dem Anmelden gibt es keinen Vorgänger und keine übergeordnete Seite.
 */
export function BackLink({ className }: { className?: string }) {
  const rueckweg = useRueckweg();
  if (!rueckweg) return null;
  return (
    <Link
      to={rueckweg.to}
      className={cn(
        'inline-flex items-center gap-1 text-xs text-ink-500 transition-colors hover:text-ink-800',
        className,
      )}
    >
      <Icon name="ArrowLeft" size={12} /> {rueckweg.label}
    </Link>
  );
}
